<template>
  <ws-list-view
    class="ws-participants__list"
    :data="newParticipants"
    :header="false"
    :detailed="false"
  >
    <template slot-scope="props">
      <ws-participants-list-item @input-users="inputUsers" :item="props.row" :currentId="currentId" />
    </template>
    <template slot="skeleton">
      <ws-list-view-skeleton-item
        :height="'107px'"
        :boxCount="1"
        :boxHeights="['105px']"
      />
      <ws-list-view-skeleton-item
        :height="'107px'"
        :boxCount="1"
        :boxHeights="['105px']"
      />
    </template>
  </ws-list-view>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import axios from 'axios'
import WsParticipantsListItem from './WsParticipantsListItem.vue'

export default {
  name: 'WsParticipantsList',
  components: { WsParticipantsListItem },
  props: {
    guid: {
      type: String
    },
    items: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      newItems: [],
      newParticipants: [],
      isUserAgreement: false
    }
  },
  computed: {
    ...mapGetters('refbook/study_groups', {
      list: 'list'
    }),
    ...mapState('refbook/study_groups', {
      currentId: 'currentId'
    }),
    participants () {
      const items = this.getCurrentItem && this.getCurrentItem.participants
      const participants = items
        ? items.filter(item => item).reduce((x, y) => x.findIndex(e => e.guid === y.guid) < 0 ? [...x, y] : x, [])
        : []
      return participants.sort((a, b) => {
        if (a.user_info && b.user_info) {
          return (a.user_info.last.display > b.user_info.last.display) ? 1 : (a.user_info.last.display === b.user_info.last.display) ? ((a.user_info.last.display > b.user_info.last.display) ? 1 : -1) : -1
        }
      })
    },
    getCurrentItem () {
      return this.list.find(item => item.guid === this.currentId)
    },
    participantsIds () {
      if (this.participants && Array.isArray(this.participants)) {
        return this.participants.filter(p => p && p.user_info && p.user_info.guid).map(p => p.user_info.guid)
      } else {
        return []
      }
    }
  },
  watch: {
    participants () {
      this.getParticipants()
    }
  },
  mounted () {
    this.getParticipants()
  },
  methods: {
    async getParticipants () {
      if (this.participantsIds && this.participantsIds.length) {
        try {
          const res = await axios.post(`${__config.api_url}/api/auth/users-list`, {
            'guid': this.participantsIds
          })
          const newParticipants = this.participants
          if (res.data.data && Array.isArray(res.data.data) && Array.isArray(newParticipants)) {
            res.data.data.forEach(p => {
              newParticipants.forEach(np => {
                if (np.user_info && p.guid === np.user_info.guid) {
                  np.all_user_info = p
                }
              })
            })
          }
          this.newParticipants = newParticipants
        } catch (err) {
          this.newParticipants = this.participants
        }
      } else {
        this.newParticipants = this.participants
      }
    },
    inputUsers (users) {
      this.$emit('input-users', users)
    }
  }
}
</script>
<style>
.b-tooltip:not([data-label=""]):hover:before, .b-tooltip:not([data-label=""]):hover:after {
  white-space: pre;
}
</style>

<style scoped lang="scss">
.ws-participants__list {
  overflow-x: visible;
  overflow-y: visible;
}
</style>
